<template>
  <v-btn
    variant="text"
    icon
    :disabled="disabled"
    :loading="loading"
    density="compact"
    :icon-attr="computedIcon"
    :tooltip-attr="tooltip">
    <v-tooltip location="left">
      <template #activator="{ props }">
        <v-icon
          v-bind="props"
          @click.stop="handleClick($event)"
          :class="iconClass"
          :size="size"
          :disabled="disabled"
          :color="computedColor"
          v-show="!loading">
          mdi-{{ computedIcon }}
        </v-icon>
      </template>
      <span>{{ tooltip }}</span>
    </v-tooltip>
  </v-btn>
</template>

<script>
import buttonMixin from '../../mixins/buttonMixin';
import { removeEventsFromAttrs } from '@satellite/plugins/util.js';

/**
 * Icon button with a tooltip
 * @displayName Icon Button with Tooltip
 */
export default {
  mixins: [buttonMixin],
  props: {
    /**
     * Icon to display
     */
    icon: {
      type: String,
      required: false
    },
    /**
     * Color of the icon
     */
    color: {
      type: String,
      required: false
    },
    /**
     * Size of the icon
     */
    size: {
      type: String,
      required: false,
      default: 'small'
    },
    /**
     * Tooltip content to display
     */
    tooltip: {
      type: String,
      required: true
    },
    /**
     * Shortcut for creating red trash icons for delete
     */
    delete: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Shortcut for creating blue pencil icons for edit
     */
    edit: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * Classes to apply to the icon "e.g: 'mr-2 mt-1'"
     */
    iconClass: {
      type: String,
      required: false,
      default: ''
    },
    /**
     * Disable button and display loading spinner
     */
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    removeEventsFromAttrs
  },
  computed: {
    computedColor() {
      if (this.$props.color) {
        return this.color;
      }
      if (this.delete) {
        return 'error';
      }
      if (this.edit) {
        return 'secondary';
      }

      return 'secondary';
    },
    computedIcon() {
      if (this.$props.icon) {
        return this.icon.replace('mdi-', '');
      }
      if (this.delete) {
        return 'delete-outline';
      }
      if (this.edit) {
        return 'pencil';
      }

      return 'information-outline';
    }
  }
};
</script>
